import { httpRetry } from '$core/helpers/http-retry';
import { Config } from '$core/models/config';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  public config: Config = { urls: {} };

  constructor(
    private http: HttpClient,
    private injector: Injector
  ) {}

  public loadConfig(): Promise<boolean> {
    try {
      return new Promise((resolve, reject) => {
        this.http
          .get<Config>('/v1/config')
          .pipe(
            catchError((err) => {
              if (err.status === 503) {
                return of({ urls: {} });
              }
              return throwError(err);
            }),
            httpRetry()
          )
          .subscribe(
            (response) => {
              this.config = response;
              resolve(true);
            },
            (err: HttpErrorResponse) => {
              this.config = { urls: {} };
              reject(true);
            }
          );
      });
    } catch (error) {
      console.log(error);
    }
  }

  public urlByService(name: string): string {
    for (const [key, value] of Object.entries(this.config.urls)) {
      if (value === name) {
        return key;
      }
    }
    return '';
  }
}
